import React from 'react';
import ReactMarkdown from 'react-markdown';

// Rendu markdown partagé des mini-cours : utilisé par le composant MiniCours de la page
// d'exercice et par la bibliothèque « Mes mini-cours » de la page de progression.
const MiniCoursContent: React.FC<{ markdown: string }> = ({ markdown }) => (
  <div className="prose prose-sm max-w-none dark:prose-invert">
    <ReactMarkdown
      components={{
        strong: ({ children }) => (
          <strong className="font-bold text-blue-800 dark:text-blue-200 bg-blue-100 dark:bg-blue-900/50 px-1 rounded">
            {children}
          </strong>
        ),
        blockquote: ({ children }) => (
          <blockquote className="border-l-4 border-yellow-400 dark:border-yellow-600 bg-yellow-50 dark:bg-yellow-900/20 pl-4 py-2 my-3 italic text-yellow-800 dark:text-yellow-200">
            {children}
          </blockquote>
        ),
        code: ({ children }) => (
          <code className="bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-1.5 py-0.5 rounded text-sm font-mono">
            {children}
          </code>
        ),
        p: ({ children }) => <p className="mb-3 text-gray-700 dark:text-gray-300 leading-relaxed">{children}</p>,
      }}
    >
      {markdown}
    </ReactMarkdown>
  </div>
);

export default MiniCoursContent;
